<script>
    export default {
        props: {
            currentPage: Number,
            maxPage: Number,
        },
        methods: {
            async backPage() {
                if (this.currentPage - 1 < 0) return;
                this.$emit('back');
            },
            async nextPage() {
                if (this.currentPage + 1 > this.maxPage) return;
                this.$emit('next');
            },
            async firstpage() {
                if (this.currentPage === 0) return;
                this.$emit('first');
            },
            async lastPage() {
                if (this.currentPage === this.maxPage) return;
                this.$emit('last');
            }
        }
    }
</script>


<template>
    <div>
        <button @click="firstpage" class="mr_5">First</button>
        <button @click="backPage()">Back</button>
        <label>{{ currentPage + 1 }} / {{ maxPage + 1 }}</label>
        <button @click="nextPage()">Next</button>
        <button @click="lastPage" class="ml_5">Last</button>
    </div>
</template>


<style scoped>
    div {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 5px;
    }

    label {
        margin-left: 20px;
        margin-right: 20px;
        font-size: large;
        color: var(--background-text);
    }

    button {
        background-color: var(--header-button);
        color: var(--header-button-text);
        border-radius: 5px;
        border: var(--border);
        padding: 5px;
        min-width: 70px;
        font-weight: bold;
        cursor: pointer;
    }
    button:hover {
        background-color: var(--header-button-hover);
    }
</style>